import { Observable } from 'rxjs';
import { createSelectMap } from '@ngxs/store';
import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AddApplicationPayload, LanguageGroupListItem, LanguageGroupListSelectionPayload } from '../model';
import { ApplicationSelectorState, ConfigState } from './state';

@Injectable({
  providedIn: 'root',
})
export class ApplicationService {
  private readonly http = inject(HttpClient);

  selectors = createSelectMap({
    baseApiUrl: ConfigState.baseApiUrl,
    application: ApplicationSelectorState.application,
    environment: ApplicationSelectorState.environment,
  });

  addApplication(payload: AddApplicationPayload): Observable<void> {
    const url = `${this.selectors.baseApiUrl()}/applications`;
    return this.http.post<void>(url, payload);
  }

  getLanguageGroups(): Observable<Array<string>> {
    const url = `${this.selectors.baseApiUrl()}/applications/${this.selectors.application()}/env/${this.selectors.environment()}/groups`;
    return this.http.get<Array<string>>(url);
  }

  getLanguageListOfGroup(groupName: string): Observable<Array<LanguageGroupListItem>> {
    const url = `${this.selectors.baseApiUrl()}/applications/${this.selectors.application()}/env/${this.selectors.environment()}/group/${groupName}/list`;
    return this.http.get<Array<LanguageGroupListItem>>(url);
  }

  addLanguageGroup(group: string, cloneGroup?: string): Observable<void> {
    const url = `${this.selectors.baseApiUrl()}/applications/${this.selectors.application()}/env/${this.selectors.environment()}/groups`;
    return this.http.post<void>(url, { group, cloneGroup });
  }

  deleteLanguageGroup(group: string): Observable<void> {
    const url = `${this.selectors.baseApiUrl()}/applications/${this.selectors.application()}/env/${this.selectors.environment()}/groups`;
    return this.http.request<void>('delete', url, { body: JSON.stringify(group) });
  }

  updateLanguageListSelectionStatus(groupName: string, payload: LanguageGroupListSelectionPayload): Observable<void> {
    const url = `${this.selectors.baseApiUrl()}/applications/${this.selectors.application()}/env/${this.selectors.environment()}/group/${groupName}/list`;
    return this.http.patch<void>(url, payload);
  }
}
